<div class="row m-b-16  m-t-10">
  @for(record of medicalRecords; track record.id) {
  <div class="col-lg-3 col-sm-6 cursor-pointer" appLazyPreview (previewVisible)="onPreviewVisible(record)">
    <mat-card class="file-card shadow-none border overflow-hidden">
      <div class="file-card-preview d-flex align-items-center justify-content-center bg-light-primary"
        (click)="openPreview(record)">
        @if (record.previewType === 'image' && record.previewUrl) {
        <img [src]="record.previewUrl" [alt]="record.description" class="preview-image"
          (error)="onPreviewLoadError(record)" />
        } @else if (record.previewType === 'pdf' && record.previewUrl) {
        <iframe [src]="record.previewUrl" class="preview-frame" title="Medical record preview"
          (error)="onPreviewLoadError(record)"></iframe>
        } @else {
        <div class="file-fallback d-flex flex-column align-items-center justify-content-center">
          <mat-icon class="text-primary preview-icon">description</mat-icon>
          <span class="file-extension">{{ getFileBadgeLabel(record) }}</span>
        </div>
        }

      </div>
      <mat-card-content class="p-16">
        <div class="file-content-header d-flex align-items-start justify-content-between">
          <div class="file-info">
            <h4 class="mat-subtitle-1 f-w-600 text-truncate m-b-4" [title]="record.description">
              {{ record.description || 'Medical Record' }}
            </h4>
            <div class="d-flex align-items-center gap-8">
              <span class="mat-body-2 text-muted">{{ record.uploadDate }}</span>
              <span class="dot-separator"></span>
              <span class="mat-body-2 text-muted">{{ getRecordTypeLabel(record.type) }}</span>
            </div>
          </div>
          <div class="file-actions">
            <a mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <i-tabler name="dots-vertical" class="icon-20"></i-tabler>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openPreview(record)">
                <mat-icon>visibility</mat-icon>
                <span>Preview</span>
              </button>
              <button mat-menu-item (click)="onDownload(record)">
                <mat-icon>download</mat-icon>
                <span>Download</span>
              </button>
              <button mat-menu-item (click)="onDelete(record)" class="text-danger">
                <mat-icon class="text-danger">delete</mat-icon>
                <span class="text-danger">Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</div>